var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shops-table"},[_c('WarehouseManagementHead',{attrs:{"showFilter":_vm.showFilter},on:{"toggleFilter":_vm.toggleFilter}}),_c('div',{staticClass:"table-filter-wrap"},[_c('WarehouseManagementTable',{on:{"showMore":_vm.showMore}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }